/** Converte um valor em dólar para real. Valores já em BRL voltam sem alteração. */
export function convertCurrency(
  value: number | string | undefined,
  currency: string | undefined,
  brlQuote: number | undefined,
) {
  if (currency === 'BRL') return value;

  return Number(value) * Number(brlQuote);
}
